module.exports = __webpack_public_path__ + "static/media/23.a870185b.png";